import { useEffect, useState } from "react";
import Paragraph from "../components/atoms/paragraph";
import Image from "../components/atoms/image";
import Top from "../components/templates/top";
import Title from "../components/atoms/title";
import Button from "../components/atoms/button";
import listText from "../utils/dictionaries/dictionary-congratulation";
import party from "../assets/icons/party.svg";
import { store } from "../redux/store";
import PersonalDataService from "../services/personalData.service";
import { DataINEuseCase } from "../../application/use-cases/dataINE.usecase";
import MessagesReactModal from "../components/templates/messages-react-modal";
import hexagonExclamationThin from "../assets/icons/hexagon-exclamation-thin.svg";
import ic_xclose from "../assets/icons/ic_xclose.svg";

const Congratulation = () => {
  const state = store.getState();
  const [waitProcess, setwaitProcess] = useState(true);
  const [modalShow, setModalShow] = useState(false);
  const [clientId, setClientId] = useState(null);
  const getDataINEService = new PersonalDataService();
  const usecasegetDataINE = new DataINEuseCase(getDataINEService);

  const getPersonData = async () => {
    const response = await usecasegetDataINE.getDataINE(state.client.clientPersist.uuid);
    console.log(response);
    if (response.error != null) {
      setModalShow(true);
      setwaitProcess(true);
    } else {
      setClientId(response.data.clientId);
      setwaitProcess(false);
    }
  };

  useEffect(() => {
    return () => {
      getPersonData();
    };
  }, []);

  const endN4 = () => {
    window.ReactNativeWebView.postMessage(
      JSON.stringify({
        type: "ENROLLED_USER_N4",
        data: {
          curp: state.client.confirmData.curp,
          clientId: clientId,
          cellphone: state.client.dataPersist.phone,
        },
      }),
    );
  };

  return (
    <>
      <div className="content-container">
        <Top
          titleHeader={listText.text_1.mainText}
          subTitle={""}
          displayProgressBar={"d-none"}
          displayLeftImageTitle={"d-none"}
          classTitleImage={"d-none"}
          classHeader={"mt-2"}
          styleHeader={{}}
          classProgressBar={"d-none"}
          styleProgressBar={{}}
          classTitleAndImage={"d-none"}
          styleTitleAndImage={{}}
          valueProgressBar={""}
          comeFrom={"/Congratulation"}
          onClickGoBackIcon={undefined}
        />
        <div className="p-3">
          <div className="text-center my-5">
            <Image
              srcImage={party}
              className={""}
              alt={""}
              dataBsDismiss={undefined}
              styleImg={undefined}
              onClick={undefined}
            />
          </div>
          <div className="text-center mb-3">
            <Title
              text={listText.text_2.mainText}
              className={""}
              styleTitle={{
                fontWeight: "700",
                fontSize: "28px",
                fontFamily: "Roboto",
                color: "#00254A",
              }}
            />
          </div>
          <div className="text-center mb-3">
            <Paragraph
              text={listText.text_3.mainText}
              className={""}
              styleParagraph={{
                fontWeight: "400",
                fontSize: "20px",
                fontFamily: "Roboto",
                color: "#00254A",
              }}
            />
          </div>
          <div>
            <Paragraph
              text={listText.text_4.mainText}
              className={""}
              styleParagraph={{
                fontWeight: "400",
                fontSize: "16px",
                fontFamily: "Roboto",
                color: "#00254A",
              }}
            />
          </div>
        </div>
      </div>
      <div className="footer--pin">
        <Button
          text={listText.text_5.mainText}
          divClassName={"d-grid gap-2"}
          buttonClassName={`button-enabled w-100 place-content-center align-self-center`}
          spinner={waitProcess}
          onClick={() => endN4()}
          disabled={waitProcess}
          dataBsDismiss={undefined}
        />
      </div>
      <MessagesReactModal
        show={modalShow}
        onHide={() => setModalShow(false)}
        textTitle="¡Ups lo sentimos!"
        classTitle={"fw-bold"}
        styleTitle={{ color: "#00254A", fontSize: "20px", fontWeight: "700" }}
        listButtonsModal={[
          {
            text: "Reintentar",
            style: {},
            divClass: "",
            buttonClass: "button-enabled w-100 place-content-center align-self-center mt-3",
            spinner: false,
            onClick: () => setModalShow(false),
            disabled: false,
          },
        ]}
        imageModal={hexagonExclamationThin}
        onClickClose={() => setModalShow(false)}
        imageOnlyClose={ic_xclose}
        classContent={"ml-3 mr-3 mb-3 text-center"}
        classImageModal={"text-center my-4"}
        listParagraphs={[
          {
            textParagraph:
              "La aplicación no esta respondiendo debido a que hay problemas con la comunicación de nuestros sistemas.",
            classParagraph: "mt-2 mx-2",
            styleParagraph: { fontSize: 16, color: "#00254A", fontWeight: "450" },
          },
          {
            textParagraph: "Vuelve a intentar si el error persiste.",
            classParagraph: "mt-2 mx-2",
            styleParagraph: { fontSize: 16, color: "#00254A", fontWeight: "450" },
          },
        ]}
      />
    </>
  );
};

export default Congratulation;
